<!-- -*- mode: vue -*- -->
<template>
  <div>
    <v-row no-gutters>
      <v-col>

        <v-row class="mgmt-panel">
          <Breadcrumbs :breadcrumbs="breadcrumbs" />
          <v-spacer></v-spacer>
          <div class="mgmt-panel-buttons" :class="{ 'mgmt-panel-buttons-mobile': device === 'mobile' }">

<!--           <XlsButton
            :pendingXls="pendingXls"
            @generateXls="generateXls"
          /> -->
<!--           <Columns
            class="mr-2"
            :columns="columns"
            :initialFields="fields"
            :viewName="viewName"
            @filteredLoad="filteredLoad"
          /> -->
            <OperativeReportFilter
              :query="initialQuery"
              :count="count"
              :filterPending="filterPending"
              :countTotal="countTotal"
              @filteredLoad="filteredLoad"
            />
          </div>
        </v-row>


        <v-card light flat>

            <v-card-title>Опоздавшие с докладом:</v-card-title>
            <v-data-table
              must-sort
              dense
              :mobile="false"
              disable-pagination
              :headers="headersDelay"
              :loading="loading"
              :items="items.delay"
              :footer-props="footerProps"
              :header-props="{ mobile: false }"
              class="dataTable elevation-1 data-table"
              :hide-default-footer="true"
              :hide-default-header="false"
              :mobile-breakpoint="0"
              no-data-text="Нет данных"
            >
            <template v-slot:body="{ items }">
              <tbody>
                <tr align="left" v-for="(item, index) in items" :key="item.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td v-for="field in fieldsDelay" :key="field.id">
                    {{ item[field]|default }}
                  </td>
                </tr>
                <tr>
                  <td v-if="!items.length && !loading" class="center-text" colspan="100">
                    <span class="no-data-text">Нет данных</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>

          <v-card-title>Незанятые посты:</v-card-title>
            <v-data-table
              must-sort
              dense
              :mobile="false"
              disable-pagination
              :headers="headersUnoccupiedPost"
              :loading="loading"
              :items="items.unoccupied_post"
              :footer-props="footerProps"
              :header-props="{ mobile: false }"
              class="dataTable elevation-1 data-table"
              :hide-default-footer="true"
              :hide-default-header="false"
              :mobile-breakpoint="0"
              no-data-text="Нет данных"
            >
            <template v-slot:body="{ items }">
              <tbody>
                <tr align="left" v-for="(item, index) in items" :key="item.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td v-for="field in fieldsUnoccupiedPost" :key="field.id">
                    {{ item[field]|default }}
                  </td>
                </tr>
                <tr>
                  <td v-if="!items.length && !loading" class="center-text" colspan="100">
                    <span class="no-data-text">Нет данных</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>

            <v-card-title>Мобильные доклады (вне регламента):</v-card-title>
            <v-data-table
              must-sort
              dense
              :mobile="false"
              disable-pagination
              :headers="headersSuspiciousReports"
              :loading="loading"
              :items="items.suspicious_reports"
              :footer-props="footerProps"
              :header-props="{ mobile: false }"
              class="dataTable elevation-1 data-table"
              :hide-default-footer="true"
              :hide-default-header="false"
              :mobile-breakpoint="0"
              no-data-text="Нет данных"
            >
            <template v-slot:body="{ items }">
              <tbody>
                <tr align="left" v-for="(item, index) in items" :key="item.id">
                  <td>
                    {{ index + 1 }}
                  </td>
                  <td v-for="field in fieldsSuspiciousReports" :key="field.id">
                    <span v-if="field == 'pic_url' && item.pic_url"><a target="_blank" :href='item.pic.url'>фото</a></span>
                    <span v-else>{{ item[field]|default }}</span>
                  </td>
                </tr>
                <tr>
                  <td v-if="!items.length && !loading" class="center-text" colspan="100">
                    <span class="no-data-text">Нет данных</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>


        <v-card-title>События:</v-card-title>
          <v-data-table
            must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersEvent"
            :loading="loading"
            :items="items.event"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsEvent" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-card-title>Проверки:</v-card-title>
          <v-data-table
            must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersCheck"
            :loading="loading"
            :items="items.check"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsCheck" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-card-title>Проверки (видеоконтроль):</v-card-title>
          <v-data-table
            must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersCheck"
            :loading="loading"
            :items="items.check_video"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsCheck" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-card-title>Технические работы на постах:</v-card-title>
          <v-data-table
            must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersTech"
            :loading="loading"
            :items="items.tech"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsTech" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <v-card-title>Отчет о недостатках по документам:</v-card-title>
          <v-data-table
            must-sort
            dense
            :mobile="false"
            disable-pagination
            :headers="headersDocumentDeficiencies"
            :loading="loading"
            :items="items.document_deficiencies"
            :footer-props="footerProps"
            :header-props="{ mobile: false }"
            class="dataTable elevation-1 data-table"
            :hide-default-footer="true"
            :hide-default-header="false"
            :mobile-breakpoint="0"
            no-data-text="Нет данных"
          >
          <template v-slot:body="{ items }">
            <tbody>
              <tr align="left" v-for="(item, index) in items" :key="item.id">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-for="field in fieldsDocumentDeficiencies" :key="field.id">
                  {{ item[field]|default }}
                </td>
              </tr>
              <tr>
                <td v-if="!items.length && !loading" class="center-text" colspan="100">
                  <span class="no-data-text">Нет данных</span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

      </v-card>

    </v-col>
  </v-row>

  <Confirmation
  :opened="confirmation.opened"
  :title="confirmation.title"
  :text="confirmation.text"
  :pendingSave="confirmation.pendingSave"
  @confirm="confirmConfirmationAction"
  @cancel="cancelConfirmationAction"
  />
  </div>
</template>

<script>
import { getAll, xls, get, remove } from '@/api'
import IndexMixin from '@/views/Index.vue'
import ReportMixin from '@/views/Report.vue'
import Columns from '@/components/Columns'
import OperativeReportFilter from '@/components/filters/OperativeReportFilter'
import moment from 'moment'

export default {
  components: {
    OperativeReportFilter,
    Columns,
  },
  mixins: [IndexMixin, ReportMixin],
  data: function () {
    return {
      modelName: 'PostReport',
      viewName: 'rep_post_control',
      viewTitle: 'Оперативный отчет за сутки',

      urlList: 'report/operative/',

      initialQuery: {
        date: moment(new Date()).format('DD.MM.YYYY'),
      },

      columnsDelay: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Дата', align: 'left', width: 130, sortable: true, value: 'range_start', default: true },
        { text: 'Тип доклада', align: 'left', width: 130, sortable: true, value: 'report_type', default: true },
        { text: 'Пост', align: 'left', width: 220, sortable: true, value: 'post', default: true },
        { text: 'Сотрудник', align: 'left', width: 250, sortable: true, value: 'unit', default: true },
        { text: 'Отклонение (мин)', align: 'left', width: 180, sortable: true, value: 'deviation', default: true },
        { text: 'Принял', align: 'left', width: 150, sortable: true, value: 'created_by_name', default: true },
      ],

      columnsUnoccupiedPost: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Объект', align: 'left', width: 200, sortable: true, value: 'secureobject', default: true },
        { text: 'Пост', align: 'left', width: 220, sortable: true, value: 'title', default: true },
        { text: 'Подразделение', align: 'left', width: 150, sortable: true, value: 'secureobject__subdivision', default: true },
        { text: 'Организация', align: 'left', width: 150, sortable: true, value: 'secureobject__organization', default: true },
      ],

      columnsSuspiciousReports: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Дата', align: 'left', width: 130, sortable: true, value: 'range_start', default: true },
        { text: 'Тип доклада', align: 'left', width: 130, sortable: true, value: 'report_type', default: true },
        { text: 'Пост', align: 'left', width: 220, sortable: true, value: 'post', default: true },
        { text: 'Сотрудник', align: 'left', width: 250, sortable: true, value: 'unit', default: true },
        { text: 'Дистанция', align: 'left', width: 180, sortable: true, value: 'distance', default: true },
        { text: 'Фото (совпадение)', align: 'left', width: 180, sortable: true, value: 'photo_match', default: true },
        { text: 'Фото (доклад)', align: 'left', width: 180, sortable: true, value: 'pic_url', default: true },
        { text: 'Сделал', align: 'left', width: 150, sortable: true, value: 'created_by_name', default: true },
      ],

      columnsCheck: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Дата', align: 'left', width: 150, sortable: true, value: 'range_start', default: true },
        { text: 'Дата окончания', align: 'left', width: 100, sortable: true, value: 'range_end', default: true },
        { text: 'Объект', align: 'left', width: 200, sortable: true, value: 'post__secureobject', default: true },
        { text: 'Пост', align: 'left', width: 200, sortable: true, value: 'post', default: true },
        { text: 'Вид контроля', align: 'left', width: 100, sortable: true, value: 'control_type', default: true },
        { text: 'Тип проверки', align: 'left', width: 100, sortable: true, value: 'daymode_ru', default: true },
        { text: 'Сотрудник', align: 'left', width: 200, sortable: true, value: 'unit', default: true },
        { text: 'Проверяющий', align: 'left', width: 150, sortable: true, value: 'inspection', default: true },
        { text: 'Событие', align: 'left', width: 100, sortable: false, value: 'event', default: true },
        { text: 'Подразделение', align: 'left', width: 150, sortable: true, value: 'post__secureobject__subdivision', default: true },
        { text: 'Комм. к проверке', align: 'left', width: 150, sortable: true, value: 'comment', default: true },
      ],

      columnsEvent: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Дата', align: 'left', width: 150, sortable: true, value: 'date_created', default: true },
        { text: 'Тип доклада', align: 'left', width: 130, sortable: true, value: 'report_type', default: true },
        { text: 'Объект', align: 'left', width: 200, sortable: true, value: 'post__secureobject', default: true },
        { text: 'Пост', align: 'left', width: 200, sortable: true, value: 'post', default: true },
        { text: 'Событие', align: 'left', width: 150, sortable: true, value: 'event_type', default: true },
        { text: 'Сотрудник', align: 'left', width: 200, sortable: true, value: 'unit', default: true },
        { text: 'Сумма ущерба', align: 'left', width: 150, sortable: true, value: 'amount', default: true },
        { text: 'Комментарий', align: 'left', width: 150, sortable: true, value: 'comment', default: true },
        { text: 'Подразделение', align: 'left', width: 150, sortable: true, value: 'post__secureobject__subdivision', default: true },
      ],

      columnsTech: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Дата', align: 'left', width: 150, sortable: true, value: 'range_start', default: true },
        { text: 'Дата окончания', align: 'left', width: 100, sortable: true, value: 'range_end', default: true },
        { text: 'Тип тех. обслуживания', align: 'left', width: 130, sortable: true, value: 'techservice_type', default: true },
        { text: 'Объект', align: 'left', width: 200, sortable: true, value: 'post__secureobject', default: true },
        { text: 'Пост', align: 'left', width: 200, sortable: true, value: 'post', default: true },
        { text: 'Комментарий', align: 'left', width: 150, sortable: true, value: 'comment', default: true },
      ],

      columnsDocumentDeficiencies: [
        { text: '№', align: 'left', width: 50, sortable: false, value: 'index', default: true, service: true },
        { text: 'Сотрудник', align: 'left', width: 250, sortable: true, value: 'name', default: true },
        { text: 'Пост', align: 'left', width: 220, sortable: true, value: 'post', default: true },
        { text: 'Организация', align: 'left', width: 150, sortable: true, value: 'organization', default: true },
        { text: 'Подразделение', align: 'left', width: 150, sortable: true, value: 'subdivision', default: true },
        { text: 'УЧО', align: 'left', width: 150, sortable: true, value: 'guardlicense', default: true },
        { text: 'ЛК', align: 'left', width: 150, sortable: true, value: 'personalmulticard', default: true },
        { text: 'ПП', align: 'left', width: 150, sortable: true, value: 'periodictraining', default: true },
        { text: 'Комментарий', align: 'left', width: 150, sortable: true, value: 'comment', default: true },
      ]
    }
  },
  computed: {
    headersDelay () {
      return this.columnsDelay.filter(column => (this.fieldsDelay.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsDelay () {
      return this.columnsDelay.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersCheck () {
      return this.columnsCheck.filter(column => (this.fieldsCheck.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsCheck () {
      return this.columnsCheck.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersEvent () {
      return this.columnsEvent.filter(column => (this.fieldsEvent.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsEvent () {
      return this.columnsEvent.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersTech () {
      return this.columnsTech.filter(column => (this.fieldsTech.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsTech () {
      return this.columnsTech.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersUnoccupiedPost () {
      return this.columnsUnoccupiedPost.filter(column => (this.fieldsUnoccupiedPost.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsUnoccupiedPost () {
      return this.columnsUnoccupiedPost.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersSuspiciousReports () {
      return this.columnsSuspiciousReports.filter(column => (this.fieldsSuspiciousReports.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsSuspiciousReports () {
      return this.columnsSuspiciousReports.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },

    headersDocumentDeficiencies () {
      return this.columnsDocumentDeficiencies.filter(column => (this.fieldsDocumentDeficiencies.includes(column.value) && !column.hidden) || column.service)
    },
    fieldsDocumentDeficiencies () {
      return this.columnsDocumentDeficiencies.map(function (column) { if (column.default && !column.service && !column.hidden) { return column.value } }).filter(column => column !== undefined)
    },
  },
}
</script>

<style>
</style>
